import { fetchApi } from '../api/digitalVault';
import { parsePagination, parsePlaylists } from '../utils';
const getUserPlaylists = async (params = {}, logger) => {
    const rawResponse = await fetchApi(params, 'playlist', {}, false, logger);
    const { hasNextPage, nextPageParams } = parsePagination(rawResponse.playlistDefinitions.link);
    return {
        hasNextPage,
        data: await parsePlaylists(rawResponse.playlistDefinitions.playlistDefinition, true),
        paginate() {
            return hasNextPage && getUserPlaylists(nextPageParams, logger);
        },
    };
};
export default getUserPlaylists;
